import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// Disable automatic browser scroll restoration to prevent interference
if (typeof window !== "undefined") {
  window.history.scrollRestoration = "manual";
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Instantly scroll to top synchronously before the browser paints the new page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
    
    // Re-initialize and refresh AOS to bind animations on the new page components
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
    AOS.refresh();
  }, [pathname]);

  return null;
};

export default ScrollToTop;